import { PAYMENT_ERROR_MESSAGE } from 'app-constants'
import { STATICS } from 'statics'
import './style.scss'

export function PaymentError({ hasError = false }) {
  if (!hasError) return null

  return (
    <div className='payment-error-container'>
      <STATICS.INFO_CIRCLE className='icon' />
      <p className='text'>{PAYMENT_ERROR_MESSAGE}</p>
    </div>
  )
}
